import {HANES_TAGLESS, HANES_ESSENTIAL} from './ProductConstants';

export const SIMPLE_PRICING_FLAG = 'simple_pricing_v7';
export const UPLOAD_ONE_COLOR_FLAG = 'uploadOneColor_v2';
export const UPLOAD_AUTO_SIZING_FLAG = 'upload_auto_sizing_v3';
export const WAYS_TO_ORDER_FLAG = 'ways_to_order_v6';

export default {
  autoFitText: {
    flags: {
      test1: 0,
      test2: 0,
      test3: 0,
      test4: 0,
      test5: 0,
      test6: 0,
      control: 0,
      excluded: 1
    }
  },
  defaultBlank_v9: {
    flags: {
      [HANES_TAGLESS.flagName]: 0,
      [HANES_ESSENTIAL.flagName]: 0,
      excluded: 1
    }
  },
  embroiderySleeveStyles_v2: {
    flags: {
      test: 1,
      control: 0,
      excluded: 0
    }
  },
  singlesPricingMessage_v4: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    }
  },
  uploadColorRemoval: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    }
  },
  uploadCTA_v2: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    }
  },
  uploadResolution_v3: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    }
  },
  [UPLOAD_ONE_COLOR_FLAG]: {
    flags: {
      test: 1,
      control: 0,
      excluded: 0
    }
  },
  decoration_overrides_v1: {
    flags: {
      test: 1,
      control: 0,
      excluded: 0
    }
  },
  [SIMPLE_PRICING_FLAG]: {
    flags: {
      test: 0,
      control: 0,
      excluded: 1
    }
  },
  [UPLOAD_AUTO_SIZING_FLAG]: {
    flags: {
      test: 1,
      control: 0,
      excluded: 0
    }
  },
  [WAYS_TO_ORDER_FLAG]: {
    flags: {
      test: 0.1,
      control: 0.1,
      excluded: 0.8
    }
  }
};
